import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

import Home from '@/views/Home.vue';
import Pricing from '@/views/Pricing.vue';
import WPBusiness from '@/views/WPBusiness.vue';
import Integrations from '@/views/Integrations.vue';
import UniversalInbox from '@/components/UniversalInbox.vue';
import WhatsAppCampaign from '@/components/WhatsAppCampaign.vue';
import Support from '@/views/Support.vue';
import Automotive from '@/views/Automotive.vue';
import LocalBusiness from '@/views/LocalBusiness.vue';
import ElectronicCommerce from '@/views/ElectronicCommerce.vue';
import Tourism from '@/views/Tourism.vue';
import Finance from '@/views/Finance.vue';
import Wholesale from '@/views/Wholesale.vue';
import Pharmacy from '@/views/Pharmacy.vue';
import AboutUs from '@/views/AboutUs.vue';
import Contact from '@/views/Contact.vue';
import Privacy from '@/views/Privacy.vue';
import Terms from '@/views/Terms.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/products',
    children: [
      {
        path: 'wp-business',
        component: WPBusiness
      },
      {
        path: 'integrations',
        component: Integrations
      },
      {
        path: 'universal-inbox',
        component: UniversalInbox
      },
      {
        path: 'whatsapp-campaign',
        component: WhatsAppCampaign
      },
      {
        path: 'support',
        component: Support
      }
    ]
  },
  {
    path: '/solutions',
    children: [
      {
        path: 'automotive',
        component: Automotive
      },
      {
        path: 'local-business',
        component: LocalBusiness
      },
      {
        path: 'electronic-commerce',
        component: ElectronicCommerce
      },
      {
        path: 'tourism',
        component: Tourism
      },
      {
        path: 'finance',
        component: Finance
      },
      {
        path: 'wholesale',
        component: Wholesale
      },
      {
        path: 'pharmacy',
        component: Pharmacy
      }
    ]
  },
  {
    path: '/pricing',
    component: Pricing
  },
  {
    path: '/about-us',
    component: AboutUs
  },
  {
    path: '/contact-us',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    return { left: 0, top: 0 };
  }
});

export default router;
